import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { DocumentsLaunchService } from '@iupics-components/specific/window/document-explorer-ui/documents-launch.service';
import { UICreatorService } from '@iupics-manager/managers/ui-creator/ui-creator.service';
import { WorkspaceService } from '@web-desktop/components/workspace/components/workspace-ui/workspace.service';
import { IupicsMenuType } from '@web-desktop/models/menu-item-ui';
import { TranslateModule } from '@ngx-translate/core';
import { DataStoreKey } from '@compiere-ws/models/compiere-data-json';
import { DocServerService } from '@compiere-ws/services/doc-server/doc-server.service';
import InputFileUiComponent from '@iupics-components/standard/fields/input-file-ui/input-file-ui.component';

@Component({
  selector: 'iu-join-file-ui',
  templateUrl: './join-file-ui.component.html',
  styleUrls: ['./join-file-ui.component.scss'],
  standalone: true,
  imports: [InputFileUiComponent, TranslateModule],
})
export default class JoinFileUiComponent implements OnInit {
  private readonly docServerService = inject(DocServerService);
  private readonly uiCreator = inject(UICreatorService);
  private readonly workspaceService = inject(WorkspaceService);
  private readonly documentsLaunch = inject(DocumentsLaunchService);
  /** menu entry of the Documents window when the role has it (button shown) */
  documentsMenu: { id: number } | null = null;
  @Input()
  adTable_ID!: number;
  @Input()
  adTab_ID!: number;
  record_id: any;
  @Input()
  dsKey!: DataStoreKey;
  @Input()
  nbUploadedFiles = 0;
  @Input()
  data: any;
  @Input()
  fromNotes = false;

  @Output() nbUploadedFilesChange = new EventEmitter<number>();
  @Output() cancelEmitter = new EventEmitter<any>();
  @Output() uploadEnd = new EventEmitter<any>();
  @Output() openFileOnSideEmitter = new EventEmitter<any>();

  baseSearch: any;
  tags: any;

  ngOnInit(): void {
    const recordId = this.dsKey.recordId.split(',');
    this.record_id =
      recordId.length > 1 ? (isNaN(parseInt(recordId[1], 10)) ? recordId[1] : parseInt(recordId[1], 10)) : -1;

    this.baseSearch = this.docServerService.initBaseSearch(this.dsKey, this.data, this.adTable_ID);
    this.tags = this.docServerService.initTags(this.dsKey, this.data, this.adTable_ID, this.fromNotes);
    if (!this.fromNotes && typeof this.record_id === 'number' && this.record_id > 0 && this.adTable_ID) {
      this.uiCreator.getIupicsMenus().subscribe((menus) => {
        const menu = menus?.find((m) => m.angularClass === 'DocumentExplorerUiComponent' && m.menuType === IupicsMenuType.FORM);
        this.documentsMenu = menu ? { id: menu.actionID } : null;
      });
    }
  }

  /** Documents window filtered on this record */
  openDocuments(event: Event): void {
    event.stopPropagation();
    if (!this.documentsMenu) return;
    this.documentsLaunch.request({ tableId: this.adTable_ID, recordId: this.record_id });
    this.workspaceService.openTargetSearchEmt.emit({
      cat: { id: this.documentsMenu.id },
      source: { id: null, menuType: IupicsMenuType.FORM },
    });
  }

  cancel(event: Event): void {
    event.stopPropagation();
    this.cancelEmitter.emit();
  }

  updateNbUploadedFiles(nb: number): void {
    this.nbUploadedFiles = nb;
    this.nbUploadedFilesChange.emit(this.nbUploadedFiles);
  }

  openFileOnSide(additionalInfo: any): void {
    this.openFileOnSideEmitter.emit(additionalInfo);
  }
}
